(function () {
  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function initOneSection(sectionEl) {
    if (!sectionEl) return;

    var sliderEl = sectionEl.querySelector('.products-onsale-slider.swiper');
    if (!sliderEl) return;

    // Buttons within this section only
    var prevBtn = sectionEl.querySelector('.onsale-slider-prev');
    var nextBtn = sectionEl.querySelector('.onsale-slider-next');

    // Destroy existing instance cleanly
    if (sliderEl.swiper && typeof sliderEl.swiper.destroy === 'function') {
      try { sliderEl.swiper.destroy(true, true); } catch (e) {}
    }

    if (typeof Swiper === 'undefined') return;

    var mobile = toInt(sliderEl.dataset.mobile, 1);
    var desktop = toInt(sliderEl.dataset.desktop, 8);

    new Swiper(sliderEl, {
      slidesPerView: mobile,
      spaceBetween: 12,
      loop: false,
      watchOverflow: true,

      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },

      breakpoints: {
        576: { slidesPerView: 2 },
        700: { slidesPerView: 4 },
        850: { slidesPerView: 6 },
        1080: { slidesPerView: desktop }
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.products-slider-section');
    for (var i = 0; i < sections.length; i++) initOneSection(sections[i]);
  }

  function boot() {
    initAll();

    // ResizeObserver per section (no global thrash)
    if ('ResizeObserver' in window) {
      var sections = document.querySelectorAll('.products-slider-section');
      sections.forEach(function (sectionEl) {
        if (sectionEl.__fgOnSaleRO) return;
        sectionEl.__fgOnSaleRO = new ResizeObserver(function () {
          initOneSection(sectionEl);
        });
        sectionEl.__fgOnSaleRO.observe(sectionEl);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e && e.target ? e.target : null;
    if (sectionEl && sectionEl.classList && sectionEl.classList.contains('products-slider-section')) {
      initOneSection(sectionEl);
    } else {
      initAll();
    }
  });
})();